import { graphql } from 'gatsby';
import Seo from 'gatsby-plugin-wpgraphql-seo';
import React from 'react';
import styled from 'styled-components';
import '../../../fragments';
import RawLayout from '../../../layout/raw-layout';


const StyledIframe = styled.iframe`
  height: 100svh;
  width: 100svw;
  border: none;
`;

const TemplateEmbed = ({
  data: {
    post,
  },
}) => {
  const {
    template: {
      acfEmbed: {
        embedIframe: {
          url
        }
      },
    },
  } = post;
  const { language, translations, uri } = post;
  return (
    <RawLayout currentLanguage={{ language, uri }} translations={translations}>
      <StyledIframe
        title='embed-iframe'
        src={url}
        frameborder="0"
        allowfullscreen="true"
        mozallowfullscreen="true"
        webkitallowfullscreen="true">
      </StyledIframe>
      <Seo post={post} />
    </RawLayout>
  );
};

export const query = graphql`
  query TemplateEmbed(
    $id: String!
  ) {
    post: wpPage(id: { eq: $id }) {
      ...PostContent
      template {
        ... on WpTemplate_Embed {
          acfEmbed {
            embedIframe {
              url
            }
          }
        }
      }
    }
  }
`;

export default TemplateEmbed;
